import { CreateCompanyForm } from '@forms/create-company-form';
import { Prospect } from '@gi/models/prospect';
import { BusinessUnit } from '@models/business-unit';
import { CreateCompany } from '@models/create-company';
import { CreateCompanyFormDisplayedForms } from '@shared-forms/create-company-form/create-company-form.component';

export type CreateCompanyAvailableStep = 'User' | 'Company' | 'Invitation' | 'Parameters';

export abstract class CreateCompanyState {
  readonly form: CreateCompanyForm = new CreateCompanyForm();

  abstract availableSteps: CreateCompanyAvailableStep[];
  abstract companyStepDisplayedForms: CreateCompanyFormDisplayedForms[];

  abstract initForm(businessUnits: BusinessUnit[], prospect?: Prospect): void;

  abstract toCreateCompany(): CreateCompany;
}
